import { render, staticRenderFns } from "./chateau-les-grands-chenes.vue?vue&type=template&id=2d6a64e9&scoped=true"
import script from "./chateau-les-grands-chenes.vue?vue&type=script&lang=js"
export * from "./chateau-les-grands-chenes.vue?vue&type=script&lang=js"
import style0 from "./chateau-les-grands-chenes.vue?vue&type=style&index=0&id=2d6a64e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6a64e9",
  null
  
)

export default component.exports